import { getSafeAreaPaddings, getTheme } from "@clipboard-health/ui-theme";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";

import { PageWrapper } from "../../redesign/components/PageWrapper";
import { Navbar } from "../../redesign/Navbar";
import { LegacyChatListPage } from "./LegacyChatListPage";
import { ChatListPage } from "./Page";

export function ChatListContainer() {
  return (
    <ThemeProvider theme={getTheme()}>
      <CssBaseline />
      <PageWrapper
        variant="tertiary"
        sx={{
          ...getSafeAreaPaddings({
            top: true,
          }),
        }}
      >
        <Box sx={{ flex: 1, overflow: "auto" }}>
          <ChatListPage />
        </Box>
        <Navbar />
      </PageWrapper>
    </ThemeProvider>
  );
}

export function LegacyChatListContainer() {
  return (
    <ThemeProvider theme={getTheme()}>
      <CssBaseline />
      <PageWrapper
        variant="tertiary"
        sx={{
          ...getSafeAreaPaddings({
            top: true,
          }),
        }}
      >
        <Box sx={{ flex: 1, overflow: "auto" }}>
          <LegacyChatListPage />
        </Box>
        <Navbar />
      </PageWrapper>
    </ThemeProvider>
  );
}
